export default __webpack_public_path__ + "static/media/help.43736371.svg";